import { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { startCheckout } from "../lib/billing";
import { S, C } from "../ui";
import lockupLight from "../assets/lockup-light.svg";

// Shown to a Facility Admin whose licenses/{uid} doc is missing or
// canceled (see App.jsx). Vendor Admins never see this — the property
// manager pays, vendors are invited in free (spec's business model).
export default function PaywallScreen({ uid, canceled }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const start = async () => {
    setBusy(true); setErr("");
    try {
      // Carries a cold-outreach email's ?ref=<leadId> (if present) through
      // to Stripe metadata so a real signup can be traced back to the
      // email that drove it — see outreach.js's withRef() on the sending
      // side and outreachConversions on the read side.
      const referralLeadId = new URLSearchParams(window.location.search).get("ref") || undefined;
      const { url } = await startCheckout(uid, referralLeadId);
      window.location.href = url;
    } catch (e) {
      setErr("Couldn't start checkout — try again.");
      setBusy(false);
    }
  };

  return (
    <div style={S.center}>
      <div style={S.card}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
          <img src={lockupLight} alt="Edifice View" style={{ height: 36 }} />
        </div>
        <div style={S.title}>{canceled ? "Your subscription has ended" : "Start your free trial"}</div>
        <div style={S.sub}>
          $149/mo per facility, unlimited vendors and workers — plus $100/mo
          for each additional building you add. 14 days free, no card
          required to start.
        </div>
        {err && <div style={S.err}>{err}</div>}
        <button style={{ ...S.btn(), marginBottom: 10 }} disabled={busy} onClick={start}>
          {busy ? "Starting…" : canceled ? "Resubscribe" : "Start 14-Day Free Trial"}
        </button>
        <button style={S.ghostBtn} onClick={() => signOut(auth)}>Sign Out</button>
      </div>
    </div>
  );
}
